export const SET_USER = 'SET_USER';
export const SET_USER_STATE_ITEM = 'SET_USER_STATE_ITEM';
export const RESET_STATE = 'RESET_STATE';
export const SET_CONTACT = 'SET_CONTACT';

export enum UserMutations {
    SET_CUSTOMER_OPTIONS = 'SET_CUSTOMER_OPTIONS',
}
